import styled from 'styled-components';

export const StyleWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  width: 100%;
  height: 58px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  box-shadow: 0px 1px #EBE7EC;
  .LeftWrapper {
    width: 20%;
    display: flex;
    justify-content: flex-start;
  }
  .CenterWrapper {
    width: 60%;
    display: flex;
    justify-content: center;
  }
  .RightWrapper {
    width: 20%;
    display: flex;
    justify-content: flex-end;
  }
`;
export default StyleWrapper;
